import React from 'react'
import ReactPaginate from "react-paginate";
import { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
//import { Navigate, useNavigate } from 'react-router-dom';
import Notification from "../../Notification";
export default function UtilizeMessages() {

    const [searchData, setsearchData] = useState('');
    const [items, setItems] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [loading, setLoading] = useState(false)
    const [isChecked, setisChecked] = useState(false);
    // const [sorting, setSorting] = useState([]);
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const [perPage, setPerpage] = useState(1)

    useEffect(() => {
        const getUtilizeMessagesList = async () => {
    const res = await Axios.post(`api/business/utilize-messages-list?pageNo=1&perPage=${perPage}`);

    const responseData = res?.data?.data?.[0];

    setItems(responseData?.data || []);
    setTotalPage(responseData?.totalPage || 0);
    setpageCount(Math.ceil(responseData?.totalPage || 0));
    };
        getUtilizeMessagesList ();
    }, [perPage]);

    if (loading && items.length === 0) {
        return <h2>Loading...</h2>
    }
    const fetchgetUtilizeMessagesList = async (currentPage) => {
    const res = await Axios.post(`api/business/utilize-messages-list?pageNo=${currentPage}&perPage=${perPage}`);

    const responseData = res?.data?.data?.[0];

    setItems(responseData?.data || []);
};

    const handlePageClick = async (items) => {
        console.log(items.selected);

        let currentPage = items.selected + 1;
        const searchBy =  document.getElementById("search_by_id").value;
        if(searchData !== "" && searchBy !== ""){
            await searchHandle (currentPage)
        }else{

            await fetchgetUtilizeMessagesList(currentPage);
        }

        
    };
    const handleChange = (e) => {
        // alert("Hi");
        const { name, checked } = e.target;

        if (name === "allSelect") {
            let tempItems = items.map((countryList) => {
                return { ...countryList, isChecked: checked };
            });
            //   console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);
        }
        else {
            let tempItems = items.map((countryList) =>
                countryList.country_id === name ? { ...countryList, isChecked: checked } : countryList
            );
            // console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);

        }
    }
   
    const searchHandle = async (currentPage) => {

    const searchBy = document.getElementById("search_by_id").value;

      if (searchData !== "" && searchBy !== "") {

      alert("hello");

    try {

        const res = await Axios.post(`api/business/utilize-messages-list?pageNo=${currentPage}&perPage=${perPage}&searchData=${searchData}&search_by=${searchBy}`);

        console.log("hii", res);

        const responseData = res?.data?.data?.[0];

        if (responseData?.data?.length > 0) {
            setItems(responseData.data);
            setTotalPage(responseData.totalPage);
            setpageCount(Math.ceil(responseData.totalPage));
        } else {
            setItems([]);
            setTotalPage(responseData?.totalPage || 0);
            setpageCount(Math.ceil(responseData?.totalPage || 0));
        }

    } catch (error) {
        console.log("Search Error:", error);
        setItems([]);
    }

} else {

    setNotify({
        isOpen: true,
        messsage: `Search By and Search Value Should Not Be Blank!`,
        type: 'error',
    });

}

};

    return (
        <>
            <div className="content-page">
                <div className="content"><h1>{totalPages}</h1>
                    {/* <!-- Start Content--> */}
                    <div className="container-fluid">

                        {/* <!-- start page title --> */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    
                                    <h4 className="page-title">Utilization Messages</h4>
                                </div>
                            </div>
                        </div>
                        {/* <!-- end page title -->  */}

                        <div className="row">
                            <div className="col-12">
                                <div className="card-box table-responsive">
                                    {/* <span className="header-title"><b>Utilization Messages</b></span>&nbsp;&nbsp;&nbsp;
                                    <button className="btn btn-danger" type="button" value="Deleted" onClick={(e) => alldelete(e)} >DELETE</button>&nbsp;&nbsp;&nbsp;
                                    <button className="btn btn-primary" type="button" value="Active" onClick={(e) => alldelete(e)}  >Active All</button>&nbsp;&nbsp;&nbsp;
                                    <button className="btn btn-primary" type="button" value="Inactive" onClick={(e) => alldelete(e)}>Inactive All</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                                    {
                                        notify.isOpen ?
                                            <Notification
                                                notify={notify}
                                                setNotify={setNotify} />
                                            : ""
                                    }
                                      <span><b>Search By:-</b></span>
                                             <select name="search_by" id="search_by_id">
                                            <option value="">Select</option>
                                            <option value="business_name">Business Name</option>
                                            <option value="package_name">Package Name</option>
                                           
                                            
                                        </select>&nbsp;&nbsp;&nbsp;
                                        <input type="" className='search-business-list' placeholder='Search...'
                                         onChange={(e) => setsearchData(e.target.value)}
                                        />
                                        <button type="Search" className="find-list"onClick={searchHandle}>Search</button>


                                    <table id="datatable" className="table table-bordered  dt-responsive nowrap" style={{ padding: "30px", margin: "20px" }}>
                                        <thead>
                                            <tr>
                                                <td><input
                                                    type="checkbox"
                                                    name="allSelect"
                                                    checked={!items.some((countryList) => countryList?.isChecked !== true)}
                                                    onChange={handleChange} /> <label className="form-check-label ms-2">All Select</label></td>

                                                <td>S.No</td>
                                                <td >Business Id</td>
                                                <td >Plan Id </td>
                                                <td >Bought Plan Id</td>
                                                <td >Business Name</td>
                                                <td >Package Name</td>
                                                <td >Total Message</td>
                                                <td >Left Message</td>
                                                <td >Status</td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {items.map((UtilizeMessages, index) =>
                                                <tr key={index}>
                                                    <td><input
                                                        type="checkbox"
                                                        name={[UtilizeMessages.business_id]}
                                                        checked={UtilizeMessages?.isChecked || false}
                                                        onChange={handleChange}
                                                    />  </td>
                                                    <td>{index + 1}</td>
                                                    <td>{UtilizeMessages.business_id}</td>
                                                    <td>{UtilizeMessages.plan_id}</td>
                                                    <td>{UtilizeMessages.bought_plan_id}</td>
                                                    <td>{UtilizeMessages.business_name}</td>
                                                    <td>{UtilizeMessages.package_name}</td>
                                                    <td>{UtilizeMessages.total_message}</td> 
                                                    <td>{UtilizeMessages.left_message}</td>
                                                    <td>{UtilizeMessages.status}</td>
                                                    
                                                </tr>)}
                                        </tbody>
                                    </table>
                                    <ReactPaginate
                                        previousLabel={"previous"}
                                        nextLabel={"next"}
                                        breakLabel={"..."}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination justify-content-center"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                    <div>
                                        <span><b>Rows per page:-</b></span>
                                        <select name="Rows per page" onChange={(e) => setPerpage(e.target.value)}>
                                            <option value="">Select Item Per Page</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="30">30</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                        </select>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container-fluid --> */}

                </div>
            </div>
        </>
    )
}
